export default "__VITE_ASSET__KIS5s0FZ__"